import { ILOV } from '@interfaces/DataSubjectRightLookups.interface';

export const getOptionByKey = (key: string, list: ILOV[]): ILOV | undefined => {
  return list.find((item) => item.value === key);
};
